import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FeedbackWithGoHomeComponent } from '../feedback-with-go-home/feedback-with-go-home.component';

@Component({
  selector: 'app-unauthorized',
  imports: [CommonModule, FeedbackWithGoHomeComponent],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent {}
